'use client';

import Image from 'next/image';
import classes from './FullScreenImageHalf.module.scss';
import { Box } from '@mantine/core';

type FullscreenImageProps = {
  src?: string;
  alt?: string;
  title: string;
  subtitle: string;
};

const FullScreenImageHalf = ({ data }: { data: FullscreenImageProps }) => {
  const { src, alt, title, subtitle } = data;
  return (
    <>
      <div className={classes.padding} />
      <Box className={classes.box}>
        <Image
          src={src ?? ''}
          alt={alt ?? ''}
          fill
          className={classes.background}
          style={{ objectFit: 'cover' }}
        />
        <div className={classes.content}>
          <h1 className={classes.title}>{title}</h1>
          <h3 className={classes.subtitle}>{subtitle}</h3>
        </div>
      </Box>
    </>
  );
};

export default FullScreenImageHalf;
